/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthUpdatePasswordResponse } from "./AuthUpdatePasswordResponse";

export type AuthUpdatePasswordResponseApiRespoonse = {
  data?: AuthUpdatePasswordResponse;
  status?: AuthUpdatePasswordResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AuthUpdatePasswordResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
